import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './adminlogin.css';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Simple hardcoded admin check (temporary)
    if (credentials.username === 'admin' && credentials.password === 'admin#123$') {
      // Set admin session with timestamp
      const loginData = {
        username: 'admin',
        role: 'super_admin',
        loginTime: new Date().toISOString()
      };
      
      // Use sessionStorage instead of localStorage (clears on tab close)
      sessionStorage.setItem('adminLoggedIn', 'true');
      sessionStorage.setItem('adminData', JSON.stringify(loginData));
      
      navigate('/admin/dashboard');
    } else {
      setError('Invalid username or password');
    }
    setLoading(false);
  };

  return (
    <div className="admin-login-wrapper">
      <div className="admin-login-container">
        <div className="login-header">
          <div className="logo-section">
            <div className="logo-icon">🎓</div>
            <h1 className="app-title">Smart AI Tutor</h1>
          </div>
        </div>

        <div className="login-card">
          <h2 className="login-title">Admin Login</h2>
          <p className="login-subtitle">Enter your credentials to access the admin panel</p>
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                placeholder="Enter your username"
                value={credentials.username}
                onChange={(e) => setCredentials({...credentials, username: e.target.value})}
                required
                autoFocus
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                placeholder="Enter your password"
                value={credentials.password}
                onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                required
              />
            </div>
            
            {error && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {error}
              </div>
            )}
            
            <button type="submit" disabled={loading} className="login-button">
              {loading ? (
                <>
                  <span className="loading-spinner"></span>
                  Logging in...
                </>
              ) : (
                <>
                  <span>🔓</span>
                  Login
                </>
              )}
            </button>
          </form>
        </div>

        <div className="login-footer">
          <p>© 2025 Smart AI Tutor. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;